import styled, { css } from 'styled-components';
import { BORDER_RADIUS, COLOURS, SHADOWS, Z_INDEX } from '@belong/themes';

export const ChatDialog = styled.dialog<{ isFullScreen?: boolean }>`
  all: unset;
  position: fixed;
  overflow: hidden;
  background: ${COLOURS.WHITE};
  display: flex;
  flex-direction: column;

  ${props =>
    props.isFullScreen
      ? css`
          z-index: ${Z_INDEX.GLOBAL_HEADER + 1};
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        `
      : css`
          z-index: ${Z_INDEX.GLOBAL_HEADER - 1};
          right: 20px;
          bottom: 0;
          width: 375px;
          max-width: calc(100% - 20px);
          height: 666px;
          max-height: calc(100vh - 10px);
          border: 1px solid ${COLOURS.GREY_300};
          border-bottom: none;
          border-radius: ${BORDER_RADIUS.CARD} ${BORDER_RADIUS.CARD} 0 0;
          box-shadow: ${SHADOWS.AMBIENT_LIGHT};
        `}
`;
